/**
 * Whether signing in can work here at all.
 *
 * The app is served from two very different places. On a Mac it comes from a
 * backend that is right there. On a phone it comes from the connect service,
 * which is a static host and a switchboard: it serves the page and introduces
 * two devices, and it has no API of its own on purpose. There is nothing to
 * sign in to until the phone is joined to a Mac, and from then on every call
 * travels down the tunnel to that machine.
 *
 * So a login screen on a phone that has not paired yet cannot work, whichever
 * button you press. On 27 July Frank pressed "Sign in with SPEAQ ID" there
 * four times and got "Method Not Allowed", because a POST to a service with
 * no POST routes is exactly that. Password and Google answered the same way.
 * The screen looked like three doors; all three were painted on.
 *
 * This is the same failure as 26 July, one screen further along: an interface
 * that presents itself as working while every call behind it fails. The fix is
 * the same shape too. Ask first, and when the answer is no, say so and offer
 * the one road that does lead somewhere.
 */

/** A backend is reachable. The sign-in methods can do their work. */
export const HERE = "here";
/** No backend yet. The only way forward is joining a machine. */
export const PAIR_FIRST = "pair-first";
/** Not known yet. Show neither, because guessing is what caused this. */
export const ASKING = "asking";

/**
 * @param tunnelLive      the channel to a Mac is up, so calls have somewhere to go
 * @param backendAnswered true, false, or null while we do not know
 */
export function whereCanISignIn({ tunnelLive = false, backendAnswered = null } = {}) {
  // A live tunnel is a backend by definition: the calls are already being
  // carried to one. No need to ask, and asking would go down the channel.
  if (tunnelLive) return HERE;
  if (backendAnswered === null) return ASKING;
  return backendAnswered ? HERE : PAIR_FIRST;
}
